import { Injectable } from "@angular/core";
import { IOpportunityAdditionalDiscount, IOpportunityBundleDetail, IOpportunityBundleDetailSubTax, IOpportunityProductSubTax, OpportunityAddEditProductsM } from "../models/opportunity-add-edit.models";

@Injectable({
    providedIn: "root",
})
export class OpportunityProductRequestModelBuilderService {
    mapProductsToOpportunity(products, opportunityId, crudType): any {
        const opportunityProducts = products?.map((product) => {
            const opportunityProduct: OpportunityAddEditProductsM = this.mapProduct(product, opportunityId, crudType);
            return opportunityProduct;
        });

        const opportunityAddDiscount = this.mapDiscount(products, opportunityId);

        return {
            opportunityProducts,
            opportunityAddDiscount,
        };
    }

    private mapProduct(product, opportunityId, crudType): OpportunityAddEditProductsM {
        return {
            id: crudType == 'clone' ? 0 : product?.id ?? 0,
            opportunityId: opportunityId,
            productId: product?.productId ?? 0,
            itemNo: product?.itemNo ?? "",
            description: product?.description ?? "",
            uomId: product?.uomId ?? 0,
            qty: product?.qty ?? 0,
            price: product?.price ?? 0,
            totalAmount: product?.totalAmount ?? 0,
            statusId: 1,
            warehouseId: product?.warehouseId ?? 0,
            createdSource: product?.createdSource,
            updatedSource: product?.updatedSource,
            createdBy: product?.createdBy,
            updatedBy: product?.updatedBy,
            createdDate: product?.createdDate,
            updatedDate: product?.updatedDate,
            typeId: product?.typeId ?? 0,
            subTotal: product?.baseSubTotal ?? 0,
            costPrice: product?.costPrice ?? 0,
            totalCostPrice: product?.totalCostPrice ?? 0,
            discountId: product?.discount?.id ?? 0,
            discountRate: product?.discountRate ?? 0,
            discountTypeId: product?.discount?.discountBy ?? 0,
            discountAmount: product?.discountAmount ?? 0,
            additionalDiscount: 0,
            additionalFeesId: product?.handlingFee?.id ?? 0,
            additionalRate: product?.handlingFeeRate ?? 0,
            additionalAmount: product?.handlingFeeAmount ?? 0,
            taxId: 0,
            taxName: "",
            taxRateTypeId: 0,
            taxRate: 0,
            opportunityBundleProducts: this.mapBundles(product, product?.bundleDetails, crudType, opportunityId),
            opportunityProductSubTax: this.mapProductSubTax(product, opportunityId, crudType),
        };
    }

    private mapDiscount(products, opportunityId): IOpportunityAdditionalDiscount[] {
        return [
            {
                id: 0,
                opportunityId: opportunityId,
                discountId: products?.discount?.id ?? 0,
                discountTypeId: products?.discount?.discountTypeId ?? 0,
                discountAmount: products?.discount?.discountValue ?? 0,
                discountRate: products?.discount?.discountValue ?? 0,
                description: products?.discount?.additionalDescription ?? "",
            },
        ];
    }

    private mapBundles(product, bundleDetails, crudType, opportunityId): IOpportunityBundleDetail[] {
        return (
            bundleDetails?.map((bundle) => {
                const opportunityBundleDetail: IOpportunityBundleDetail = {
                    id: crudType == 'clone' ? 0 : bundle?.id ?? 0,
                    createdSource: bundle?.createdSource,
                    updatedSource: bundle?.updatedSource,
                    createdBy: bundle?.createdBy,
                    updatedBy: bundle?.updatedBy,
                    createdDate: bundle?.createdDate,
                    updatedDate: bundle?.updatedDate,
                    opportunityProductId: crudType == 'update' ? product?.id ?? 0 : 0,
                    productId: product?.productId ?? 0,
                    subProductId: bundle?.productId ?? 0,
                    price: bundle?.price ?? 0,
                    totalAmount: bundle?.totalAmount ?? 0,
                    orderQty: bundle?.qty ?? 0,
                    orderPrice: bundle?.price ?? 0,
                    totalPrice: bundle?.totalAmount ?? 0,
                    statusId: 1,
                    binId: bundle?.binId ?? 0,
                    description: bundle?.description ?? "",
                    totalQty: bundle?.totalQuantity ?? 0,
                    subTotal: bundle?.baseSubTotal ?? 0,
                    parentBundleId: 0,
                    costPrice: bundle?.costPrice ?? 0,
                    totalCostPrice: bundle?.totalCostPrice ?? 0,
                    typeId: bundle?.typeId ?? 0,
                    uomId: bundle?.uomId ?? 0,
                    discountId: bundle?.discount?.id ?? 0,
                    discountRate: bundle?.discountRate ?? 0,
                    discountTypeId: bundle?.discount?.discountBy ?? 0,
                    discountAmount: bundle?.discountAmount ?? 0,
                    additionalDiscount: 0,
                    additionalFeesId: bundle?.handlingFee?.id ?? 0,
                    additionalRate: bundle?.handlingFeeRate ?? 0,
                    additionalAmount: bundle?.handlingFeeAmount ?? 0,
                    taxId: 0,
                    taxName: "",
                    taxRateTypeId: 0,
                    taxRate: 0,
                    opportunityBundleDetailSubTax: this.mapBundleDetailSubTax(bundle, opportunityId, crudType),
                };
                return opportunityBundleDetail;
            }) || []
        );
    }

    private mapProductSubTax(item, opportunityId, crudType): IOpportunityProductSubTax[] {
        const totalTaxRate = item?.subTaxes?.reduce((sum, item) => sum + item.taxRate, 0);
        return item?.subTaxes?.map(subTax => ({
            id: crudType == 'clone' ? 0 : item?.id > 0 ? subTax.id ?? 0 : 0,
            opportunityProductId: crudType == 'clone' ? 0 : opportunityId > 0 ? item.id ?? 0 : 0,  
            taxId: item?.id > 0 ? subTax.taxId : subTax.id ?? 0,  
            subTaxId: item?.id > 0 ? subTax.subTaxId : subTax.id ?? 0,
            subTaxCodeId: 0,  
            taxRate: subTax.taxRate ?? 0,
            taxAmount: ((subTax.taxRate / totalTaxRate) * item.taxAmount),
            statusId: 1,
            createdSource: item?.createdSource,
        }));
    }

    private mapBundleDetailSubTax(item, opportunityId, crudType): IOpportunityBundleDetailSubTax[] {
        const totalTaxRate = item?.subTaxes?.reduce((sum, item) => sum + item.taxRate, 0);
        return item?.subTaxes?.map(subTax => ({
            id: crudType == 'clone' ? 0 : item?.id > 0 ? subTax.id ?? 0 : 0,
            opportunityBundleDetailId: crudType == 'clone' ? 0 : opportunityId > 0 ? item.id ?? 0 : 0, 
            taxId: item?.id > 0 ? subTax.taxId ?? 0 : subTax.id ?? 0,  
            subTaxId: item?.id > 0 ? subTax.subTaxId ?? 0 : subTax.id ?? 0,
            subTaxCodeId: 0,  
            taxRate: subTax.taxRate ?? 0,
            taxAmount: ((subTax.taxRate / totalTaxRate) * item.taxAmount),
            statusId: 1,
            createdSource: item?.createdSource,
        }));
    }
}
